import React, { Component } from 'react';
import { FormSpy } from 'react-final-form';
import { modalOpen } from '../../actions/modals';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const mapStateToProps = state => ({  });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ modalOpen }, dispatch);
};


class SignupModalTriggerComponent extends Component {
  
  componentWillReceiveProps (nextProps) {
    const { submitError, onSuccess, initialValues, forceSignup } = nextProps
    if ( submitError && submitError.match(/sign\s+?(up|in)|signature/i) ){
      this.props.modalOpen('signup', {size: "md", onSuccess, initialValues, isLogin: !forceSignup && !!submitError.match(/signature/i)});
    }
  }
  
  render() {
    return null
  }
}
const SignupModalTrigger = (props) => (
  <FormSpy
    {...props}
    subscription={{ submitError: true, submitErrors: true }}
    component={connect(mapStateToProps, matchDispatchToProps)(SignupModalTriggerComponent)}
  />
)

export default SignupModalTrigger;


// WEBPACK FOOTER //
// ./src/components/auth/SignupModalTrigger.js